export default __webpack_public_path__ + "static/media/AdobeStock_383328673.0316c008.jpeg";